import { QueryKeys } from "../../utils/queryKeys";

export const interventionKeys = {
  all: [QueryKeys.INTERVENTION_LEVEL_WISE_QUESTION],

  levelWiseQuestion: (args) => {
    const {
      gradeId , 
      languageId,
      domainCategoryId,
      domainMasterId,
      classroomObservationId,
      inputLevelId,
    } = args;

    return [
      ...interventionKeys.all,
      gradeId , 
      languageId,
      domainCategoryId,
      domainMasterId,
      classroomObservationId,
      inputLevelId,
    ];
  },
};